export default __webpack_public_path__ + "03797aa9d08a216ed90efab2b59e0114.png";